import { selectPartnerId } from 'legacy/lut/features/partner360/configuration'
import { createSelector } from 'reselect'

import type { TKeyInitiativesFinancialData } from 'partner360/features/keyInitiatives/model/financialData'

import { OVERALL_CATEGORY } from '../../lib/revenueAndSob/constants'

import { selectCanonicalCockpitFinSobRows } from './selectCanonicalCockpitFinSobRows'
import { selectCockpitOffering } from './selectCockpitOffering'
import { selectEffectiveCockpitFYear } from './selectEffectiveCockpitFYear'

export const selectCockpitRequirementsFinancialData = createSelector(
  [
    selectCanonicalCockpitFinSobRows,
    selectPartnerId,
    selectCockpitOffering,
    selectEffectiveCockpitFYear,
  ],
  (rows, partnerId, offering, fYear): TKeyInitiativesFinancialData[] => {
    const planRows = rows.filter(
      (row) =>
        row.partnerId.trim().toLowerCase() === partnerId.trim().toLowerCase() &&
        row.offering.trim() === offering.trim() &&
        row.fYear === fYear &&
        row.fQuarter === 5 &&
        row.isTarget &&
        !row.isNoSplit &&
        !row.isPartnerCount &&
        row.category !== 'jbp-total' &&
        (row.category === OVERALL_CATEGORY ||
          (row.subCategory === 'jbp-overall' &&
            (!row.l3Category || row.l3Category === 'jbp-overall')))
    )
    const totalScopes = new Set(
      planRows.filter((row) => row.category === OVERALL_CATEGORY).map((row) => row.isActuals)
    )
    const planNdp = planRows.reduce((sum, row) => {
      if (row.category !== OVERALL_CATEGORY && totalScopes.has(row.isActuals)) return sum
      return sum + (Number(row.totalSumNdp) || 0)
    }, 0)
    return [{ PlansCYNdp: planNdp }]
  }
)
